import type { IVector2, IVector3 } from '@seddi/math-v2';
import WaGarmentsGeometry from '@seddi/wa-garments-geometry';

type PointQueryRes = {
  coordinates: IVector3;
  triangle: number;
};

export class TriMeshGrid2 {
  pGrid: WaGarmentsGeometry.TriMeshGrid2F | null;

  private pGridIndices: WaGarmentsGeometry.StdVectorU | null;
  private pGridVertices: WaGarmentsGeometry.StdVectorPoint2F | null;

  constructor() {
    this.pGrid = null;
    this.pGridIndices = null;
    this.pGridVertices = null;
  }

  dispose() {
    if (this.pGrid) {
      // manually free attached wasm objects
      this.pGrid.delete();
      this.pGridIndices.delete();
      this.pGridVertices.delete();
      this.pGrid = null;
      this.pGridIndices = null;
      this.pGridVertices = null;
    }
  }

  init(indices: Uint32Array, vertices: Float32Array, cellSize: number) {
    if (this.pGrid) {
      console.warn('[TriMeshGrid2] You should call dispose before init to avoid memory leaks');
    }

    const nIndices = indices.length;
    const nVertices = vertices.length / 2;
    const pGridIndices = new WaGarmentsGeometry.StdVectorU();
    pGridIndices.resize(nIndices);
    pGridIndices.data().set(indices);
    const pGridVertices = new WaGarmentsGeometry.StdVectorPoint2F();
    pGridVertices.resize(nVertices);
    pGridVertices.data().set(vertices);
    const pGrid = new WaGarmentsGeometry.TriMeshGrid2F(pGridIndices, pGridVertices, cellSize);
    pGrid.build();

    this.pGrid = pGrid;
    this.pGridIndices = pGridIndices;
    this.pGridVertices = pGridVertices;
  }

  query(point: IVector2): PointQueryRes {
    const res = this.pGrid!.query(point);
    return {
      coordinates: { x: res.coordinates[0], y: res.coordinates[1], z: res.coordinates[2] },
      triangle: res.triangle,
    };
  }
}
